export default function assignIf (target, ...sources) {
  if (sources) {
    for (const source of sources) {
      if (!source) continue
      Object.keys(source).forEach(key => {
        const v = source[key]
        if (v !== undefined && v !== null && v !== '') target[key] = v
      })
    }
  }
  return target
}
